import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';
import type {
  MarketTemplateComponent,
  SingleMarketTemplateProps
} from '@swf/sports/types/templates';

import SelectionList from '../../components/SelectionList/SelectionList';

import styles from './TimedList.scss';

const TimedList: MarketTemplateComponent<
  SingleMarketTemplateProps & {
    showPreviousPrice?: true;
  }
> = ({ marketId, showPreviousPrice }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const market = useSelector((state: RootState) => widgetSelect.market(state, marketId));

  if (!market) return null;

  const { runners, marketTime } = market;

  return (
    <SelectionList
      as="dl"
      data-testid="market-template-timed-list"
      className={styles.wrapper}
      market={market}
    >
      {marketTime && (
        <SelectionList.Title data-testid="market-template-timed-list-title">
          <FormattedDateTime date={marketTime} />
        </SelectionList.Title>
      )}
      {runners.map((runner) => (
        <SelectionList.Item
          key={runner.selectionId}
          runner={runner}
          showPreviousPrice={showPreviousPrice}
        />
      ))}
    </SelectionList>
  );
};

TimedList.marketTemplateType = 'BASE';

export default TimedList;
